import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-crown-upload-excel',
  templateUrl: './crown-upload-excel.component.html',
  styleUrls: ['./crown-upload-excel.component.scss']
})
export class CrownUploadExcelComponent implements OnInit {

  uploadHidden = false;
  excel_data: any;
  approvedReject: any = [];
  offerId = "";
  voucherData: any;
  uploadId: any = [];
  caplimt: any;
  apiData: any;
  tableData = {
    headers: [],
    rows: [],
    keys: []
  }
  specialFlag = 0
  cartonId: any = "";
  SpecialOcceranceExcelData: any = []
  speciadatelData: any = []
  isExcelUpload: boolean = false;
  brandList = [];
  campaignDeatail: any;
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private router: Router,


  ) {
    this.uploadId = this.activatedRoute.snapshot.paramMap.get("id")
  }

  ngOnInit() {
    this.campaignDeatail = JSON.parse(localStorage.getItem("crown_collection"))
    this.getBrand();

  }
  getBrand() {
    this.apiService.get(this.apiconfig.crownBrand).subscribe((res: any) => {
      console.log(res)
      this.brandList = res.data;
    })
  }



  openUploadmodel(modal) {
    this.modalService.open(modal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  uploadXlsx(eve, modal) {
    // debugger
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      console.log(res)
      if (this.uploadId == 2) {
        this.whitelistUpload(res.data)
      }
      else if (this.uploadId == 3) {
        this.PointConfigurationUpload(res.data);
      }
      else if (this.uploadId == 4) {
        this.targetListUpload(res.data)
      }

    })
  }




  whitelistUpload(res) {
    let excelData = []
    res.filter((e: any) => {
      if (e['Outlet Code'] != undefined) {
        excelData.push(e)
      }
    })
    setTimeout(() => {
      let payload = {
        file: excelData,
        campaign_id: this.campaignDeatail.campaign_id
      }
      this.tableData.headers = [];
      this.tableData.rows = [];
      this.tableData.keys = [];
      this.apiService.post(this.apiconfig.uploadWhiteListCrown, payload).subscribe((res: any) => {
        console.log(res)
        this.toast.Success("success")
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.rejected_data;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      }, err => {
        console.log(err)
        this.toast.Error(err)
      })
    }, 1000)
  }

  PointConfigurationUpload(res) {
    let excelData = []
    res.filter((e: any) => {
      if (e['Outlet Code'] != undefined) {
        excelData.push(e)
      }
    })
    setTimeout(() => {
      let payload = {
        file: excelData,
        campaign_id: this.campaignDeatail.campaign_id
      }
      this.tableData.headers = [];
      this.tableData.rows = [];
      this.tableData.keys = [];
      this.apiService.post(this.apiconfig.uploadCrownPoints, payload).subscribe((res: any) => {
        console.log(res)
        console.log(res)
        this.toast.Success("success")
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.rejected_data;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      }, err => {
        console.log(err)
        this.toast.Error(err)

      })
    }, 1000);

  }



  targetListUpload(res) {
    console.log(res)

    let excelData = []
    res.filter((e: any) => {
      if (e['Outlet Code'] != undefined) {
        excelData.push(e)
      }
    })
    setTimeout(() => {
      let payload = {
        file: excelData,
        campaign_id: this.campaignDeatail.campaign_id
      }
      this.tableData.headers = [];
      this.tableData.rows = [];
      this.tableData.keys = [];

      this.apiService.post(this.apiconfig.uploadCrownTarget, payload).subscribe((res: any) => {
        console.log(res)
        this.toast.Success("success")
        this.uploadHidden = true;
        this.apiData = res.body.data;
        this.tableData.headers = ["Outlet Code", "Reason"]
        this.tableData.rows = res.body.data.rejected_data;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
        console.log(this.tableData)
      }, err => {
        console.log(err)
        this.toast.Error(err)

      })
    }, 1000)
  }

  downloadExcel() {

    // upload id 2 for whitelist user
    // upload id 3 for point calculation
    // upload id 4 for target
    // upload id 5 for special occrence




    if (this.uploadId == 2) {
      let sheetName = "Whitelist";
      let filename = "Crown_Collection_Outlets_and_CSM_Whitelisting_";
      let excelData = [{ Outlet_Code: "12345", Min_Limit: '80', Max_Limit: "100" }]
      let excelArray = [
        {
          header: "Outlet Code",
          key: "Outlet Code"
        },
        {
          header: "Mobile Number",
          key: "Mobile Number"
        },
        {
          header: "Month",
          key: "Month"
        },
        {
          header: "Year",
          key: "Year"
        },
      ]
      this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
    } else if (this.uploadId == 3) {
      let sheetName = "Points Structure";
      let filename = "Crown_Collection_Outlets_Per_Crown_Payout_Value_Allocation_";
      let excelData = [
        {
          Outlet_Code: "12345",
          Carton_Brand: '',
          Points: "10",
          Min: '90',
          Max: '100'
        }
      ]
      let excelArray = [
        {
          header: "Outlet Code",
          key: "Outlet Code"
        },
        {
          header: "Mobile Number",
          key: "Mobile Number"
        },
        {
          header: "Month",
          key: "Month"
        },
        {
          header: "Year",
          key: "Year"
        },
        {
          header: "Brand Name",
          key: "Brand Name"
        },
        {
          header: "Per Crown Payout Value",
          key: "Per Crown Payout Value"
        },
        // {
        //   header: "cap_limit_max",
        //   key: "cap_limit_max"
        // },
        // {
        //   header: "cap_limit_min",
        //   key: "cap_limit_min"
        // },
      ]
      let sheetName2 = "brands";
      let productHeader = ["Brand"]
      // this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
      this.exportExcelService.DownloadCrownSetpsExcel(filename, sheetName, excelData, excelArray, sheetName2, productHeader, this.brandList);




      // let header1 = ["Outlet Code","Carton Brand","Points","Min","Max"]
      // let sheetName1 = "Points Structure";
      // let filename = "Carton_Point_Structure";
      // this.exportExcelService.commonOneSheetPrintHeaders(header1  ,sheetName1 , filename)
    }
    else if (this.uploadId == 4) {

      let sheetName = "Sheet1";
      let filename = "Crown_Collection_Outlets_Target_";
      let excelData = [
        {
          Outlet_Code: "",
          Carton_Brand: '',
          Target_Qty: "",
        }
      ]
      let excelArray = [
        {
          header: "Outlet Code",
          key: "outlet_code"
        },
        {
          header: "Mobile Number",
          key: "mobile_number"
        },
        {
          header: "Brand Name",
          key: "brand_name"
        },
        {
          header: "Target Qty (No. of Crowns)",
          key: "target_qty"
        },
        {
          header: "Mini Target Achievement %",
          key: "minimum"
        },
        {
          header: "MaxTarget Achievement %",
          key: "maximum"
        },
        {
          header: "Label",
          key: "label"
        },

      ]
      let sheetName2 = "brands";


      let productHeader = ["Brand"]
      //  let product = [
      //    {
      //     product_type:"Per",
      //    },
      //    {
      //     product_type:"Flat",
      //   },
      // ]
      this.exportExcelService.DownloadCrownTargetSetpsExcel(filename, sheetName, excelData, excelArray, sheetName2, productHeader, this.brandList);



      // let header1 = ["Outlet Code","Carton Brand","Target Qty"]
      // let sheetName1 = "Sheet1";
      // let filename = "Carton Target";
      // this.exportExcelService.commonOneSheetPrintHeaders(header1  , sheetName1 , filename)
    }
    else if (this.uploadId == 5) {
      let filename = "Carton_Special";
      let excelHeader = ["Outlet Code",
        "Carton Brand",
        "Start Date",
        "End Date",
        "Points",
        "Scan Limit",
        "Points Type",
        //  "Mobile Number"
      ]
      let excelstatic = ["123456",
        "",
        "YYYY-MM-DD",
        "YYYY-MM-DD",
        "10",
        "80",
        "Flat"]
      let sheetName1 = "Spl Occasion";
      let sheetName2 = "Products";


      let productHeader = ["Product Type"]
      let product = [
        {
          product_type: "Per",
        },
        {
          product_type: "Flat",
        },
      ]
      this.exportExcelService.cartanSpecialOcceranceExcel(product, excelHeader, productHeader, filename, sheetName1, sheetName2, excelstatic, this.brandList);


    }
  }

  RejectedOutletExcel() {
    // common function to print rejected recoeds
    this.xlsx.export(this.tableData.rows, "rejected_list")
  }
  ngOnDestroy() {
    if (this.uploadId == 2 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "false");
      localStorage.setItem("targetFlag", "false");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 3 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "false");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 4 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      localStorage.setItem("specialOccasionFlag", "false");
    }
    else if (this.uploadId == 5 && this.isExcelUpload == false) {
      localStorage.setItem("whiteListFlag", "true");
      localStorage.setItem("pointConfigrationFlag", "true");
      localStorage.setItem("targetFlag", "true");
      localStorage.setItem("specialOccasionFlag", "true");
    }
  }




}

/**
 * @author Govadhan
 * @description In carton insert special occession when we upload excel for the first time, we send flag 0
 * In excel if difference between starte date and end date is 10 days,s then we show the list. If it is approved then => 1
 *  If reject => 2
 */

